import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () =>
    import ('../views/HomePage')
const Guarantee = () =>
    import ('../views/Guarantee')
const about = () =>
    import ('../views/about')
const info = () =>
    import ('../views/info')
const help = () =>
    import ('../views/help')
const Business = () =>
    import ('../views/Business')
const router = new VueRouter({
    mode: 'hash',
    base: __dirname,
    routes: [{
            path: '/',
            component: HomePage
        },
        {
            path: '/Guarantee',
            component: Guarantee,
        },
        {
            path: '/about',
            component: about,
        },
        {
            path: '/info',
            component: info,
        }, {
            path: '/help',
            component: help,
        }, {
            path: '/Business',
            component: Business,
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
});


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js